export default "__VITE_ASSET__3bd39abe__"